import {useEffect, useState} from 'react';
import {createSearchParams, useNavigate} from 'react-router-dom';
import Layout, {Caricamento, Titolo, Vuoto} from '../Layout';
import {apiGet, handleApiError} from '../api';
import {dataItaliana} from '../utils';

export default function BollePage() {
    const [bolle, setBolle] = useState(null); // null = in caricamento
    const navigate = useNavigate();

    useEffect(() => {
        apiGet('/bolle-viaggianti')
            .then((data) => setBolle(data ?? []))
            .catch(handleApiError);
    }, []);

    function apriBolla(b) {
        navigate({
            pathname: '/bolla',
            search: createSearchParams({bollaNumero: b.numero, bollaData: b.data}).toString(),
        });
    }

    return (
        <Layout>
            <Titolo>Bolle in viaggio</Titolo>
            {bolle === null && <Caricamento/>}
            {bolle?.length === 0 && <Vuoto>Nessuna bolla da mostrare.</Vuoto>}
            {bolle?.map((b) => (
                <div key={`${b.numero}-${b.data}`} className="bolla-item d-flex flex-wrap align-items-center p-3 mb-3"
                     onClick={() => apriBolla(b)}>
                    <Campo etichetta="Bolla" valore={b.numero} larghezza={120}/>
                    <Campo etichetta="Ordine" valore={b.ordine} larghezza={140}/>
                    <Campo etichetta="Data" valore={dataItaliana(b.data)} larghezza={120}/>
                    <Campo etichetta="Negozio" valore={b.clienteDescr} larghezza={220}/>
                    <i className="bi-chevron-right ms-auto text-secondary"></i>
                </div>
            ))}
        </Layout>
    );
}

function Campo({etichetta, valore, larghezza}) {
    return (
        <div className="me-3" style={{minWidth: larghezza}}>
            <div className="etichetta">{etichetta}</div>
            <div className="valore">{valore}</div>
        </div>
    );
}
